export default {"src":"/_next/static/media/account.4a0d7053.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};